// Règles de cohérence d'une saisie TRS — identiques à celles du serveur
// (backend/routes/trs.py : calculer_trs). Garder les deux en phase.

// Au-delà, la production réelle dépasse nettement la capacité de la machine :
// c'est une erreur de saisie (cadence ou quantités), pas une performance.
export const PERFORMANCE_MAX = 110;

const nombre = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Calcule le TRS et contrôle la cohérence.
 * Entrées : temps planifié et arrêt en minutes, productions en unités, cadence en unités/heure.
 * Retour : { availability, performance, quality, oee, rejects, theorique, erreur }
 * « erreur » est un message en français, ou null si la saisie est cohérente.
 */
export const calculerTRS = ({ planned_time, downtime, total_production, conforming_production, theoretical_cadence }) => {
  const planifie = nombre(planned_time);
  const arret = nombre(downtime);
  const reelle = nombre(total_production);
  const conforme = nombre(conforming_production);
  const cadence = nombre(theoretical_cadence);
  const vide = { availability: 0, performance: 0, quality: 0, oee: 0, rejects: 0, theorique: 0 };

  if (planifie <= 0) return { ...vide, erreur: 'Le temps planifié doit être supérieur à 0.' };
  if (planifie > 1440) return { ...vide, erreur: 'Le temps planifié ne peut pas dépasser 1440 minutes (24 h).' };
  if (arret < 0) return { ...vide, erreur: "Le temps d'arrêt ne peut pas être négatif." };
  if (arret >= planifie) return { ...vide, erreur: "Le temps d'arrêt doit être inférieur au temps planifié." };
  if (cadence <= 0) return { ...vide, erreur: 'La cadence (ou production) théorique doit être supérieure à 0.' };
  if (reelle < 0 || conforme < 0) return { ...vide, erreur: 'Les quantités ne peuvent pas être négatives.' };
  if (conforme > reelle) return { ...vide, erreur: 'La production conforme ne peut pas dépasser la production réelle (rejets supérieurs à la production).' };

  const marche = planifie - arret;
  const theorique = (marche / 60) * cadence;
  const availability = (marche / planifie) * 100;
  const performance = (reelle / theorique) * 100;
  const quality = reelle > 0 ? (conforme / reelle) * 100 : 0;
  const oee = (availability * performance * quality) / 10000;
  const resultat = {
    availability: Math.round(availability * 10) / 10,
    performance: Math.round(performance * 10) / 10,
    quality: Math.round(quality * 10) / 10,
    oee: Math.round(oee * 10) / 10,
    rejects: Math.round((reelle - conforme) * 100) / 100,
    theorique: Math.round(theorique),
    erreur: null,
  };
  if (resultat.performance > PERFORMANCE_MAX) {
    resultat.erreur = `Valeurs incohérentes : la production réelle (${reelle}) dépasse la capacité théorique sur le temps de marche (${Math.round(theorique)}), soit une performance de ${Math.round(performance)} %. Vérifiez la cadence ou la production théorique.`;
  }
  return resultat;
};
